import { useRouter } from 'next/router'
import Script from 'next/script'
import React, { useEffect } from 'react'

const GoogleAnalytics: React.FC<{ gaId: string }> = ({ gaId }) => {
  const router = useRouter()
  const { events } = router || {}

  /**
   * ページ遷移時にGoogle Analyticsにページビューを送信
   */
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (!window) return // SSR対策
      window.gtag('config', gaId, {
        page_path: url,
      })
    }
    events.on('routeChangeComplete', handleRouteChange)
    events.on('hashChangeComplete', handleRouteChange)
    return () => {
      events.off('routeChangeComplete', handleRouteChange)
      events.off('hashChangeComplete', handleRouteChange)
    }
  }, [events, gaId])

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="ga-init" strategy="afterInteractive">
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}', {
          page_path: window.location.pathname,
        });
      `}
      </Script>
    </>
  )
}

export default GoogleAnalytics
